// @flow
/* eslint-disable react/no-unused-prop-types */

import * as React from 'react';
import BootstrapAlert from 'react-bootstrap/lib/Alert';

type Props = {
  show?: boolean,
  children?: React.Node,
  mode?: 'success' | 'warning' | 'danger' | 'info',
  forceShow?: boolean,
};

type State = {
  show?: boolean,
};

export default class Alert extends React.Component<Props, State> {
  static defaultProps = {
    show: false,
    mode: 'info',
    forceShow: false,
  };

  constructor(props: Props, ...rest: any) {
    super(props, rest);

    this.state = {
      show: props.show,
    };
  }

  oldDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (nextProps.show !== prevState.show) {
      if (nextProps.forceShow === true && nextProps.show === false) {
        return null;
      }

      return this.setState({
        show: nextProps.show,
      });
    }

    return null;
  }

  componentDidMount() {
    this.oldDerivedStateFromProps(this.props, this.state);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props !== prevProps) {
      this.oldDerivedStateFromProps(this.props, this.state);
    }
  }

  handleDismiss = () => {
    this.setState({ show: false });
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  render() {
    if (this.state.show) {
      return (
        <BootstrapAlert
          bsStyle={this.props.mode}
          onDismiss={this.handleDismiss}
        >
          {this.props.children}
        </BootstrapAlert>
      );
    }

    return null;
  }
}
